import { MeritIcon } from "../../../StudentPanel/Perfil/index.jsx";
import React, { useState, useEffect } from "react";
import api from "../../../../services/api";
import { fmtNum } from "../../../../shared/utils";
import { sourceImage } from "../../../../utils/source-image";
export default function AdminMeritos(props) {
  const institutionContext = props.institutionContext;
  const institutionApi = institutionContext?.http || api;
  let meritos = props.meritos;
  let setMeritos = props.setMeritos;
  let showFlash = props.showFlash;
  let activities = props.activities;
  let activitiesLength = undefined === activities ? [] : activities;
  const [editId, setEditId] = useState(null);
  const firstActivityId =
    activitiesLength.length > 0 ? activitiesLength[0].id : null;
  const [form, setForm] = useState({
    titulo: "",
    desc: "",
    meta: 10,
    cat: firstActivityId,
    tipo: "horas_total",
    cor: "#4FB3A9",
    img: null,
  });
  const [imgPrev, setImgPrev] = useState(null);
  const resolveCatLabel = (cat) => {
    const num = Number(cat);
    return (
      (!isNaN(num) &&
        num > 0 &&
        activitiesLength.find((activity) => activity.id === num)?.nome) ||
      String(cat)
    );
  };
  const resolveCatTitle = (cat) => {
    const num = Number(cat);
    if (!isNaN(num) && num > 0) {
      const activity = activitiesLength.find(
        (activityId) => activityId.id === num,
      );
      return null !== activity && undefined !== activity && activity.descricao
        ? "".concat(activity.nome, " - ").concat(activity.descricao)
        : activity?.nome || String(cat);
    }
    return String(cat);
  };
  const uniqueCats = [...new Set(meritos.map((merito) => String(merito.cat)))];
  useEffect(() => {
    if (editId) {
      const merito = meritos.find((meritoId) => meritoId.id === editId);
      if (merito) {
        setForm({
          ...merito,
        });
        setImgPrev(merito.img || null);
      }
    } else {
      const initialCat =
        activitiesLength.length > 0 ? activitiesLength[0].id : null;
      setForm({
        titulo: "",
        desc: "",
        meta: 10,
        cat: initialCat,
        tipo: "horas_total",
        cor: "#4FB3A9",
        img: null,
      });
      setImgPrev(null);
    }
  }, [editId, meritos, activitiesLength]);
  const [filtCat, setFiltCat] = useState("todas");
  const filtrados =
    "todas" === filtCat
      ? meritos
      : meritos.filter((merito) => String(merito.cat) === String(filtCat));
  return (
    <div className={"ga"}>
      <div>
        <div
          style={{
            display: "flex",
            gap: 6,
            flexWrap: "wrap",
            marginBottom: 12,
          }}
        >
          <button
            onClick={() => setFiltCat("todas")}
            className={"btn bs ".concat("todas" === filtCat ? "" : "bg")}
            style={{
              textTransform: "capitalize",
              fontSize: 11,
              whiteSpace: "nowrap",
            }}
            title={"Mostrar todos os méritos"}
          >
            {"todas"}
          </button>
          {uniqueCats.map((catKey) => (
            <button
              onClick={() => setFiltCat(catKey)}
              className={"btn bs ".concat(
                String(filtCat) === catKey ? "" : "bg",
              )}
              style={{
                textTransform: "capitalize",
                fontSize: 11,
                whiteSpace: "nowrap",
              }}
              title={resolveCatTitle(catKey)}
              key={catKey}
            >
              {resolveCatLabel(catKey)}
            </button>
          ))}
        </div>
        <div className={"meritos-grid"}>
          {filtrados.map((filtrado) => {
            const atividadeName = resolveCatLabel(filtrado.cat);
            return (
              <div
                className={"merito-card"}
                style={{
                  border: "2px solid ".concat(filtrado.cor, "22"),
                }}
                key={filtrado.id}
              >
                {filtrado.img ? (
                  <img
                    src={sourceImage(filtrado.img)}
                    alt={filtrado.titulo}
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 8,
                      objectFit: "cover",
                      margin: "0 auto 6px",
                      display: "block",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 8,
                      background: filtrado.cor,
                      margin: "0 auto 6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 20,
                    }}
                  >
                    {institutionContext ? (
                      <MeritIcon merit={filtrado} size={44} />
                    ) : (
                      "*"
                    )}
                  </div>
                )}
                <div
                  className={"merito-titulo"}
                  style={{
                    color: filtrado.cor,
                  }}
                >
                  {filtrado.titulo}
                </div>
                <div className={"merito-desc"}>{filtrado.desc}</div>
                <div
                  style={{
                    fontSize: 10,
                    color: "#B8C5CC",
                    marginTop: 4,
                  }}
                >
                  {"Meta: "}
                  {fmtNum(filtrado.meta)}
                  {" | "}
                  {atividadeName}
                </div>
                {!institutionContext?.readOnly && (
                  <div
                    style={{
                      display: "flex",
                      gap: 5,
                      marginTop: 8,
                    }}
                  >
                    <button
                      className={"btn bg bs"}
                      style={{
                        flex: 1,
                        fontSize: 10,
                      }}
                      onClick={() => setEditId(filtrado.id)}
                    >
                      {"Editar"}
                    </button>
                    <button
                      className={"btn bd bs"}
                      style={{
                        flex: 1,
                        fontSize: 10,
                      }}
                      onClick={() =>
                        (async (resultado) => {
                          try {
                            await institutionApi.delete(
                              "/meritos?id=".concat(resultado),
                            );
                            setMeritos(
                              meritos.filter(
                                (merito) => merito.id !== resultado,
                              ),
                            );
                            showFlash("Removido.", "in");
                          } catch (err) {
                            showFlash(
                              err.response?.data?.message ||
                                "Nao foi possivel remover o mérito.",
                              "er",
                            );
                          }
                        })(filtrado.id)
                      }
                    >
                      {"X"}
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
      {!institutionContext?.readOnly && (
        <form
          onSubmit={async (event) => {
            var ativo;
            event.preventDefault();
            if (!form.titulo.trim()) {
              showFlash("Título obrigatório.", "er");
              return;
            }
            if (!form.meta || form.meta <= 0) {
              showFlash("Meta deve ser maior que zero.", "er");
              return;
            }
            const dados = {
              ...form,
              titulo: form.titulo.trim(),
              desc: form.desc.trim(),
              meta: Number(form.meta),
            };
            const payload = {
              ...dados,
              tipo: form.tipo || "horas_total",
              icone: form.icone || "*",
              ativo:
                null === (ativo = form.ativo) || undefined === ativo || ativo,
              ordem: Number(form.ordem) || 0,
            };
            try {
              const responseData2 = editId
                ? await institutionApi.put(
                    "/meritos?id=".concat(editId),
                    payload,
                  )
                : await institutionApi.post("/meritos", payload);
              const saved = responseData2.data?.data ?? responseData2.data;
              if (editId) {
                setMeritos(
                  meritos.map((merito) =>
                    merito.id === editId ? saved : merito,
                  ),
                );
                showFlash("Mérito atualizado!");
                setEditId(null);
              } else {
                setMeritos([...meritos, saved]);
                showFlash("Mérito criado!");
                setForm({
                  titulo: "",
                  desc: "",
                  meta: 10,
                  cat: "horas",
                  tipo: "horas_total",
                  cor: "#4FB3A9",
                  img: null,
                });
                setImgPrev(null);
              }
            } catch (err) {
              showFlash(
                err.response?.data?.message ||
                  "Nao foi possivel salvar o mérito.",
                "er",
              );
            }
          }}
          className={"fc"}
        >
          <div
            style={{
              fontWeight: 800,
              color: "#1F4754",
              fontSize: 14,
              marginBottom: 12,
            }}
          >
            {editId ? "Editar Mérito" : "Novo Mérito"}
          </div>
          {imgPrev && (
            <img
              src={sourceImage(imgPrev)}
              alt={""}
              style={{
                width: 60,
                height: 60,
                borderRadius: 10,
                objectFit: "cover",
                marginBottom: 10,
                border: "3px solid ".concat(form.cor),
              }}
            />
          )}
          <div className={"fg"}>
            <label>{"Imagem (opcional)"}</label>
            <input
              type={"file"}
              accept={"image/*"}
              onChange={(event) => {
                const item = event.target.files[0];
                if (!item) return;
                const instance = new FileReader();
                instance.onload = (eventTarget) => {
                  setImgPrev(eventTarget.target.result);
                  setForm((resultado) => ({
                    ...resultado,
                    img: eventTarget.target.result,
                  }));
                };
                instance.readAsDataURL(item);
              }}
              className={"inp"}
            />
          </div>
          <div className={"fg"}>
            <label>{"Título *"}</label>
            <input
              className={"inp"}
              value={form.titulo}
              onChange={(event) =>
                setForm({
                  ...form,
                  titulo: event.target.value,
                })
              }
              required={true}
              placeholder={"Ex: Mestre do Tempo"}
            />
          </div>
          <div className={"fg"}>
            <label>{"Descrição"}</label>
            <input
              className={"inp"}
              value={form.desc}
              onChange={(event) =>
                setForm({
                  ...form,
                  desc: event.target.value,
                })
              }
              placeholder={"Ex: Estude 1000 horas no total"}
            />
          </div>
          <div className={"fr"}>
            <div className={"fg"}>
              <label>{"Meta (número)"}</label>
              <input
                type={"number"}
                min={"1"}
                className={"inp"}
                value={form.meta}
                onChange={(event) =>
                  setForm({
                    ...form,
                    meta: event.target.value,
                  })
                }
                required={true}
              />
            </div>
            <div className={"fg"}>
              <label>{"Cor"}</label>
              <input
                type={"color"}
                className={"inp"}
                value={form.cor}
                onChange={(event) =>
                  setForm({
                    ...form,
                    cor: event.target.value,
                  })
                }
              />
            </div>
          </div>
          <div className={"fr"}>
            <div className={"fg"}>
              <label>{"Categoria (Atividade)"}</label>
              <select
                className={"sel"}
                value={form.cat || ""}
                onChange={(event) =>
                  setForm({
                    ...form,
                    cat: Number(event.target.value) || event.target.value,
                  })
                }
              >
                {form.cat && isNaN(Number(form.cat)) && (
                  <option value={form.cat}>
                    {form.cat}
                    {" (legado)"}
                  </option>
                )}
                {activitiesLength.map((activity) => (
                  <option value={activity.id} key={activity.id}>
                    {activity.nome}
                  </option>
                ))}
              </select>
              {"checkpoints_da_atividade" === form.tipo && (
                <div
                  style={{
                    fontSize: 10,
                    color: "#B8C5CC",
                    marginTop: 4,
                  }}
                >
                  {"Conta só checkpoints em que o aluno lançou esta atividade."}
                </div>
              )}
            </div>
            <div className={"fg"}>
              <label>{"Tipo de cálculo"}</label>
              <select
                className={"sel"}
                value={form.tipo}
                onChange={(event) =>
                  setForm({
                    ...form,
                    tipo: event.target.value,
                  })
                }
              >
                {[
                  "checkpoints_da_atividade",
                  "horas_total",
                  "horas_semana",
                  "questões_total",
                  "questões_semana",
                  "resumos_total",
                  "streak",
                  "checkpoints_total",
                  "pontos_total",
                  "indicacoes_total",
                  "desafios_vencidos",
                  "videoaula_total",
                ].map((item) => (
                  <option value={item} key={item}>
                    {item.replace(/_/g, " ")}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: 8,
            }}
          >
            <button type={"submit"} className={"btn"}>
              {editId ? "Atualizar" : "Criar Mérito"}
            </button>
            {editId && (
              <button
                type={"button"}
                className={"btn bg"}
                onClick={() => setEditId(null)}
              >
                {"Cancelar"}
              </button>
            )}
          </div>
        </form>
      )}
    </div>
  );
}
export { AdminMeritos };
